import localstate from './localstate'
import statefull from './statefull'
import root from './root'

export default {
    localstate,
    statefull,
    root
}
